<template>
  <div class="pay-user">
    <div class="user-head-cover" v-if="user.userId">
      <span class="img-border">
        <img class="img" :src="user.iconUrl" />
      </span>
    </div>
    <div class="user-name" v-if="user.userId">
      <dl class="uname">{{ user.nikeName }}</dl>
      <dl class="uid">ID: {{ user.userId }}</dl>
    </div>
    <div>
      <div class="user-teacher" v-if="isNeedAuthentic && success">
        <div v-if="!user.isVipForever" class="img-text-tip">报名成功后，微信搜索“友邻外刊阅读”小程序就能学习！</div>
      </div>
      <div class="vip-tip" v-if="user.userSno">
        <p>请添加下方班主任二维码，</p>
        <p>复制您的学号并发送给班主任。</p>
        <p class="vip-tip-magin">
          学号: {{ user.userSno }}
          <span class="vip-tip-copy" @click="copyCode($event)">复制</span>
        </p>
      </div>
      <!-- 微信二维码 -->
      <div class="user-teacher" v-if="!isNeedAuthentic && success">
        <div class="img-qrcode">
          <img class="img" :src="user.adviserCode || defaultAdviserImg" />
        </div>
        <div v-if="user.adviserName" class="img-text">{{ user.adviserName || '' }}</div>
        <div class="img-text" v-if="fromIntegral">如有疑问，请联系班主任</div>
        <div class="img-text" v-else>
          <div v-if="isNative">{{ isNative ? '添加班主任微信，激活课程服务' : '添加班主任微信，激活课程服务' }}</div>
          <div v-else>添加班主任微信，激活课程服务</div>
        </div>
        <!-- <div v-if="!user.isVipForever" class="img-text-tip">若已有班主任请勿重复添加</div> -->
      </div>
      <div v-else>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { defaultAdviserImg } from '@/pages/config'
import { appUser } from '@/utils'
import { mapGetters } from 'vuex'
import copyText from '@/utils/clipboard'
import { MessageBox } from 'mint-ui'
export default {
  name: 'PayUser',
  props: {
    user: Object,
    success: { type: Boolean, default: true },
    goodsId: [Number, String],
    fromIntegral: Boolean
  },
  data() {
    return {
      defaultAdviserImg
    }
  },
  computed: {
    ...mapGetters('goods/vip', ['isNeedAuthentic']),
    isNative() {
      return appUser.isNative
    }
  },
  methods: {
    copyCode(event) {
      const text = this.user.userSno
      // const text = '无限卡019999-1234567'
      copyText(text, event)
      MessageBox({
        title: '',
        message: '学号复制成功，请扫描二维码添加班主任老师为好友，把复制好的学号发给老师',
        confirmButtonText: '我知道了',
        confirmButtonClass: 'button-i_see'
      }).then(() => {
        this.step = 2
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// 用户
.pay-user {
  text-align: center;
  padding: 24px;
  padding-bottom: 40px;
  background-color: #ffffffff;
  margin: 40px 20px 20px;
  border-radius: 10px;
  .user-head-cover {
    margin-top: -40px;
    .img-border {
      padding: 6px;
      border-radius: 50%;
      background-color: #ffffffff;
      display: inline-block;
      .img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
  }
  .user-name dl {
    font-size: 14px;
    margin: 6px;
    &.uname {
      color: #000000;
      font-weight: 500;
    }
    &.uid {
      color: #666666;
      font-weight: 400;
    }
  }
  .vip-tip {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    .vip-tip-magin {
      margin-top: 14px;
      .vip-tip-copy {
        font-size: 12px;
        color: #00b25a;
        background-color: #f0f7f7;
        padding: 3px 8px 3px 8px;
        margin-left: 6px;
        border-radius: 2px;
      }
    }
  }
  // 班主任二维码
  .user-teacher {
    margin: 20px 0;
    color: #00b25a;
    .img {
      width: 150px;
      height: 150px;
      margin: 5px 0;
      border: 1px solid #dddddd;
    }
    .img-text {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
    .img-text-tip {
      color: #999999;
      font-size: 14px;
    }
  }
}
.mint-msgbox {
  .mint-msgbox-btn.button-i_see {
    background-color: #ffde60;
    color: #63461e;
  }
}
</style>
